import { createFileRoute } from "@tanstack/react-router";
import { OrganizationParentContactsPage } from "./-components/organization-parent-contacts-page";

export const Route = createFileRoute("/_app/organizations/$organizationId/parent/adults")({
  component: AdultsRoute,
});

function AdultsRoute() {
  const { organizationId } = Route.useParams();

  return <OrganizationParentContactsPage organizationId={organizationId} />;
}
